module.exports = __webpack_public_path__ + "static/media/ico_simulation_category_lips.fed2a861.png";